import { render, staticRenderFns } from "./Storeclass.vue?vue&type=template&id=56a5c009&scoped=true&"
import script from "./Storeclass.vue?vue&type=script&lang=js&"
export * from "./Storeclass.vue?vue&type=script&lang=js&"
import style0 from "./Storeclass.vue?vue&type=style&index=0&id=56a5c009&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a5c009",
  null
  
)

export default component.exports